export default "__VITE_ASSET__dc8e8a8f__"